export const GET_EXCHANGES_SUCCESS = 'GET_EXCHANGES_SUCCESS';
export const SET_EXCHANGES_LOADING = 'SET_EXCHANGES_LOADING';
